/**
 * Canonical agenda event defaults by tag.
 *
 * Tag-based duration rationale:
 * - Focus: 60min — typical deep-work / Pomodoro-aligned session
 * - Meeting: 60min — standard meeting slot (Google Calendar default)
 * - Personal: 30min — shorter informal events (coffee, walks, calls)
 *
 * Reminder rationale (W3 lock-in 15/05/26):
 * - Focus: 15min — mental transition + setup
 * - Meeting: 15min — same
 * - Personal: 10min — light nudge for informal events (was null;
 *   user research showed informal events still benefit from a brief
 *   heads-up, but shorter than work events)
 *
 * Source of truth used by:
 * - src/components/agenda/CreateEventModal.tsx (INSERT path for all 4 voice/manual flows)
 * - src/pages/Notes.tsx (Notes↔Agenda scheduling)
 *
 * If you change these values, audit BOTH consumers. Diverging defaults
 * across the app will surprise users.
 */

export type EventTag = "Focus" | "Meeting" | "Personal";

export const EVENT_DURATION_MIN_BY_TAG: Record<EventTag, number> = {
  Focus: 60,
  Meeting: 60,
  Personal: 30,
};

export const REMINDER_MIN_BY_TAG: Record<EventTag, number | null> = {
  Focus: 15,
  Meeting: 15,
  Personal: 10,
};
